export default "__VITE_ASSET__1f46de75__"